import React, { createContext, useContext, useState, useRef, useEffect, Fragment } from 'react';
import shortid from 'shortid';
import makeDebug from 'debug';

var SimpleFileUploadContext = createContext({
  apiKey: '',
  width: 160,
  height: 160
});
var useSimpleFileUpload = function useSimpleFileUpload() {
  return useContext(SimpleFileUploadContext);
};
var SimpleFileUploadProvider = function SimpleFileUploadProvider(_ref) {
  var apiKey = _ref.apiKey,
      width = _ref.width,
      height = _ref.height,
      children = _ref.children;
  var value = {
    apiKey: apiKey,
    width: +width,
    height: +height
  };
  return /*#__PURE__*/React.createElement(SimpleFileUploadContext.Provider, {
    value: value
  }, children);
};
var debug = makeDebug('SimpleFileUpload');

var SimpleFileUpload = function SimpleFileUpload(_ref2) {
  var apiKey = _ref2.apiKey,
      onSuccess = _ref2.onSuccess,
      onDrop = _ref2.onDrop,
      width = _ref2.width,
      height = _ref2.height,
      preview = _ref2.preview,
      text = _ref2.text,
      resizeWidth = _ref2.resizeWidth,
      resizeHeight = _ref2.resizeHeight,
      resizeMethod = _ref2.resizeMethod,
      tag = _ref2.tag,
      accepted = _ref2.accepted,
      maxFileSize = _ref2.maxFileSize,
      multiple = _ref2.multiple,
      maxFiles = _ref2.maxFiles,
      removeLinks = _ref2.removeLinks,
      buttonText = _ref2.buttonText,
      buttonClass = _ref2.buttonClass;
  var sfu = useSimpleFileUpload();
  var key = sfu.apiKey || apiKey;
  width = width || sfu.width;
  height = height || sfu.height;
  text = text || "Drop file to upload";
  resizeMethod = resizeMethod || "contain";
  buttonText = buttonText || "Upload Files";
  maxFiles = maxFiles || 10;
  var small = "false";

  if (parseInt(width) < 120) {
    small = "true";
  }

  var _useState = useState(multiple),
      isMultipleUploader = _useState[0];

  var _useState2 = useState(false),
      isModalVisible = _useState2[0],
      setModalVisible = _useState2[1];

  var _useState3 = useState(0),
      numberOfFiles = _useState3[0],
      setNumberOfFiles = _useState3[1];

  var widgetId = useRef(shortid.generate());
  useEffect(function () {
    window.addEventListener('message', handleIframeMessage, false);
    return function () {
      window.removeEventListener('message', handleIframeMessage);
    };
  });

  var handleIframeMessage = function handleIframeMessage(e) {
    if (e.origin !== 'https://app.simplefileupload.com') {
      return;
    }

    if (e.data.widgetId !== widgetId.current) {
      debug('Ignoring because widgetId does not match');
      return;
    }

    if (e.data.event == 'fileUploadSuccess') {
      if (typeof onSuccess === 'function') {
        if (!isMultipleUploader && e.data.files.length == 1) {
          onSuccess(e.data.url);
        } else {
          onSuccess(e.data.files);
        }
      }

      console.log("The uploaded files are listed as an Array of File Objects below");
      console.dir(e.data.files);

      if (e.data.close === true) {
        setModalVisible(false);
        setNumberOfFiles(e.data.files.length);
      }
    }

    if (e.data.event === 'closeWidget') {
      setNumberOfFiles(e.data.numberOfFiles || 0);
      setModalVisible(false);
    }

    if (e.data.event === 'dropStarted') {
      if (typeof onDrop === 'function') {
        onDrop(e.data.url);
      }
    }
  };

  var handleOpenClick = function handleOpenClick() {
    setModalVisible(true);
  };

  var modalStyle;

  if (isMultipleUploader) {
    if (isModalVisible) {
      modalStyle = {
        border: 'none',
        display: 'block',
        background: 'transparent',
        position: 'fixed',
        zIndex: 1000000,
        top: 0,
        left: 0
      };
    } else {
      modalStyle = {
        border: 0,
        display: 'none'
      };
    }
  }

  return /*#__PURE__*/React.createElement(Fragment, null, multiple && /*#__PURE__*/React.createElement("button", {
    onClick: handleOpenClick,
    className: buttonClass
  }, numberOfFiles > 0 ? numberOfFiles + " files uploaded" : buttonText), /*#__PURE__*/React.createElement("iframe", {
    title: "Simple File Upload " + widgetId.current,
    src: "https://app.simplefileupload.com/buckets/" + key + "?widgetId=" + widgetId.current + "&preview=" + preview + "&text=" + text + "&small=" + small + "&resizeWidth=" + resizeWidth + "&resizeHeight=" + resizeHeight + "&resizeMethod=" + resizeMethod + "&tag=" + tag + "&accepted=" + accepted + "&maxFileSize=" + maxFileSize + "&multiple=" + multiple + "&maxFiles=" + maxFiles + "&removeLinks=" + removeLinks,
    className: "widgetFrame",
    width: isMultipleUploader ? '100%' : width,
    height: isMultipleUploader ? '100%' : height,
    style: modalStyle,
    frameBorder: "no"
  }));
};

export default SimpleFileUpload;
export { SimpleFileUploadContext, SimpleFileUploadProvider, useSimpleFileUpload };
//# sourceMappingURL=index.modern.js.map
